import { graphql } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { withOptimizely } from '@optimizely/react-sdk'
import { withFormik } from 'formik'
import { compose, fromRenderProps, withHandlers, withState } from 'recompose'

import { withApolloErrorModal } from 'utils/Apollo'
import { withFlowRouter } from 'utils/FlowProvider'
import { FunnelContext, FunnelContextProps } from 'utils/FunnelContext'

import { mapPropsToValues, validate } from '../Shared/form'
import personalInfoQuery from './gql/personalInfo.query.gql'
import { PersonalInfoProps } from './types'

export default ({ handleSubmit, showPhoneNumber, showNames }) =>
  compose<PersonalInfoProps, {}>(
    fromRenderProps<Partial<FunnelContextProps>, {}, Partial<FunnelContextProps>>(
      FunnelContext.Consumer,
      ({ isBackEnabled, isDynamicFunnelEnabled, routeToPage }) => ({
        isBackEnabled,
        isDynamicFunnelEnabled,
        routeToPage,
      }),
    ),
    withRouter,
    withFlowRouter,
    withOptimizely,
    withApolloErrorModal,
    graphql(personalInfoQuery, { options: { fetchPolicy: 'network-only' } }),
    withState('isModalOpen', 'setIsModalOpen', false),
    withFormik({
      enableReinitialize: true,
      mapPropsToValues: mapPropsToValues({ showPhoneNumber, showNames }),
      isInitialValid: true,
      validate,
      handleSubmit,
      validateOnChange: false,
    }),
    withHandlers({
      handleCloseModal: ({ setIsModalOpen }) => () => {
        setIsModalOpen(false)
      },
      handleOpenModal: ({ setIsModalOpen }) => () => {
        setIsModalOpen(true)
      },
      onChange: ({ handleChange, submitCount, validateForm }) => async e => {
        // https://github.com/jaredpalmer/formik/issues/1218#issuecomment-451119016
        await handleChange(e)

        // Only validate the form if the user has attempted at least one submit
        if (submitCount > 0) {
          validateForm()
        }
      },
    }),
  )
